import React from 'react';
import PropTypes from 'prop-types';

const styles = require('./partner-component.styles.scss');


export class Partner extends React.Component {
  render() {
    return (
      <div className={styles.Partner}>
        <h3>{ this.props.name }</h3>
        <p>
          <a href={ this.props.url } target='_blank'>
          {
            this.props.url
          }
          </a>
        </p>
        {
          this.props.expertise ?
            <p>{`Schwerpunkte: ${this.props.expertise.join(', ')}`}</p>:
            null
        }
      </div>
    );
  }
}

Partner.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  expertise: PropTypes.arrayOf(PropTypes.string),
}



// WEBPACK FOOTER //
// ./src/components/partner/partner.component.jsx